export enum EmployeeStatus {
  NotFound = 'not_found',
  Active = 'active',
  Offboarded = 'offboarded',
}
